// ABOUTME: Exposes pagination when an applicant timeline has more authorized contexts.
// ABOUTME: Keeps omitted destinations reachable instead of silently truncating the inbox.
import React from "react";
import { Box, Button } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

interface WhatsappInboxTimelineContinuationProps {
    conversationData: Compleo.IObject;
    loadingConversation: boolean;
    loadingMoreContexts: boolean;
    onLoadMore: () => void;
    t: (key: string, params?: Record<string, any>) => string;
}

const WhatsappInboxTimelineContinuation = ({
    conversationData,
    loadingConversation,
    loadingMoreContexts,
    onLoadMore,
    t
}: WhatsappInboxTimelineContinuationProps) => {
    if (conversationData.contextsTruncated !== true) {
        return null;
    }

    return (
        <Box marginBottom={1}>
            <Alert severity="info">
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gridGap={8}
                >
                    <span>
                        {t("timelineContextsTruncated", {
                            count: conversationData.contextLimit || 100
                        })}
                    </span>
                    <Button
                        color="primary"
                        size="small"
                        disabled={
                            loadingConversation ||
                            loadingMoreContexts ||
                            !conversationData.nextContextCursor
                        }
                        onClick={onLoadMore}
                    >
                        {loadingMoreContexts
                            ? t("loadingMoreContexts")
                            : t("loadMoreContexts")}
                    </Button>
                </Box>
            </Alert>
        </Box>
    );
};

export default WhatsappInboxTimelineContinuation;
